import { rem } from 'polished';
import { Flex, Image } from 'roo-ui/components';
import { qantasQff, qantasBusinessRewards, pointsClub, pointsClubPlus } from 'roo-ui/logos';

const brandProps = {
  qff: {
    src: qantasQff,
    alt: 'Qantas Frequent Flyer Logo',
  },
  qbr: {
    src: qantasBusinessRewards,
    alt: 'Qantas Business Rewards Logo',
  },
};

const pointsClubProps = {
  base: {
    src: pointsClub,
    alt: 'Qantas Frequent Flyer Points Club Logo',
  },
  plus: {
    src: pointsClubPlus,
    alt: 'Qantas Frequent Flyer Points Club Plus Logo',
  },
};

const PointsLogo = ({ brand, pointsClubTier }) => {
  const logoProps = brandProps[brand] || brandProps.qff;
  const pointsClubLogoProps = pointsClubProps[pointsClubTier] || null;

  return (
    <Flex flex="1 0 auto" justifyContent={['flex-start', 'flex-start']} width={['100%', '33.333%']}>
      <Image {...logoProps} width={[rem('105px'), rem('120px')]} height={[rem('44px'), rem('60px')]} inline />
      {pointsClubLogoProps && (
        <Flex borderLeft={1} borderColor="greys.alto" px={3} mx={3} my={[0, 2]}>
          <Image {...pointsClubLogoProps} width={[rem('44px'), rem('44px')]} inline />
        </Flex>
      )}
    </Flex>
  );
};

export default PointsLogo;
